
import { defineComponent, reactive } from 'vue'

// Components
import SearchForm from '@/modules/TTNModule/components/SearchForm/index.vue'
import TTNList from '@/modules/TTNModule/components/TTNList/index.vue'

// Realisations
import { TRANSIT } from '@/core/realisations/transit.realisation'

// Composable
import useNotifications from '@/common/composable/useNotifications'
import { useTitle } from 'vue-composable'
import { TTNType } from '@/core/types/transit.types'

export default defineComponent({
    components: {
        'search-form': SearchForm,
        'ttn-list': TTNList,
    },
    setup() {
        useTitle('Получение списка ТТН')
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as TTNType[],
        })

        const onSubmit = async (number: string) => {
            try {
                state.is_loading = true

                const response = await TRANSIT.getTTNS(number)
                state.list = response.data

                state.is_failed = false
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При получении списка ТТН произошла ошибка',
                })

                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        return { onSubmit, state }
    },
})
